function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { useMemo, useContext } from "react";
import { useReadingDirections } from "../../ThemeProvider/readingDirections";
import ThemeContext from "../../ThemeProvider/ThemeContext";
import { rgba } from "../../../utils/styleUtils";
var buildStyle = function(param, param1, param2) {
    var backgroundColor = param.backgroundColor, borderColor = param.borderColor, font = param.font, _size = param.size, _border = _size.border, radius = _border.radius, base = _border.base, focus = _border.focus, opacity = param.depth.opacity, animation = param.animation, end = param1.end, start = param1.start, width = param2.width, height = param2.height, padding = param2.padding, _selectedIndicatorPlacement = param2.selectedIndicatorPlacement, selectedIndicatorPlacement = _selectedIndicatorPlacement === void 0 ? 'top-end' : _selectedIndicatorPlacement, _selectedIndicatorOffset = param2.selectedIndicatorOffset, selectedIndicatorOffset = _selectedIndicatorOffset === void 0 ? padding : _selectedIndicatorOffset;
    var ref = _slicedToArray(selectedIndicatorPlacement.split('-'), 2), checkVert = ref[0], checkHo = ref[1];
    var _obj;
    return {
        container: {
            base: {
                width: width,
                height: height,
                padding: padding,
                cursor: 'default',
                pointerEvents: 'none',
                boxSizing: 'border-box',
                fontFamily: font.base.family,
                lineHeight: font.lineHeight.base,
                fontWeight: font.base.weight.regular,
                color: font.color.base,
                backgroundColor: backgroundColor.base,
                borderRadius: radius.fiveX,
                border: "".concat(base, "px solid ").concat(borderColor.soft),
                position: 'relative',
                transitionProperty: 'box-shadow, border-color',
                transitionDuration: animation.duration[100],
                transitionTimingFunction: animation.productive.easeInOut.easing
            },
            interactive: {
                cursor: 'pointer',
                pointerEvents: 'auto',
                '&:hover': {
                    border: "".concat(base, "px solid ").concat(borderColor.hover)
                },
                '&:focus-visible': {
                    outline: 'none',
                    border: "".concat(base, "px solid ").concat(borderColor.interactive.base),
                    boxShadow: "0 0 0 ".concat(focus, "px ").concat(borderColor.interactive.focus)
                }
            },
            selected: {
                '&, &:hover': {
                    border: "".concat(base, "px solid ").concat(borderColor.interactive.base),
                    boxShadow: "0 0 0 ".concat(base, "px ").concat(borderColor.interactive.base)
                },
                '&:focus-visible': {
                    outline: 'none',
                    border: "".concat(base, "px solid ").concat(borderColor.interactive.base),
                    boxShadow: "0 0 0 ".concat(base, "px ").concat(borderColor.interactive.base) + ', ' + "0 0 0 3px ".concat(borderColor.interactive.focus)
                }
            },
            error: {
                boxShadow: 'none !important',
                '&, &:hover, &:focus': {
                    border: "".concat(base, "px solid ").concat(borderColor.danger.base)
                },
                '&:focus-visible': {
                    outline: 'none',
                    boxShadow: "0 0 0 ".concat(focus, "px ").concat(borderColor.danger.focus, " !important")
                }
            },
            disabled: {
                cursor: 'default',
                backgroundColor: backgroundColor.disabled,
                border: "".concat(base, "px solid ").concat(borderColor.disabled, " !important"),
                boxShadow: 'none !important',
                '&:hover': {
                    border: "".concat(base, "px solid ").concat(borderColor.disabled)
                },
                '&:focus, &:focus-visible': {
                    outline: 'none',
                    border: "".concat(base, "px solid ").concat(borderColor.disabled)
                }
            }
        },
        content: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        },
        iconWrapper: {
            position: 'absolute',
            top: padding,
            left: padding,
            backgroundColor: backgroundColor.base,
            cursor: 'pointer'
        },
        selectedIcon: (_obj = {
            position: 'absolute',
            height: 32,
            width: 32,
            borderRadius: radius.round,
            backgroundColor: backgroundColor.interactive.fill.base,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: "0 4px 20px -4px ".concat(rgba(backgroundColor.interactive.fill.base, opacity.medium)),
            top: checkVert === 'top' ? selectedIndicatorOffset : 'auto',
            bottom: checkVert === 'bottom' ? selectedIndicatorOffset : 'auto'
        }, _defineProperty(_obj, start.direction, checkHo === 'start' ? selectedIndicatorOffset : 'auto'), _defineProperty(_obj, end.direction, checkHo === 'end' ? selectedIndicatorOffset : 'auto'), _defineProperty(_obj, "svg", {
            fill: font.color.fill
        }), _obj)
    };
};
export var useStyle = function(param) {
    var width = param.width, height = param.height, isDisabled = param.isDisabled, isRtl = param.isRtl, hasError = param.hasError, padding = param.padding, selectedIndicatorPlacement = param.selectedIndicatorPlacement, selected = param.selected, clickable = param.clickable, selectable = param.selectable, selectedIndicatorOffset = param.selectedIndicatorOffset;
    var theme = useContext(ThemeContext);
    var direction = useReadingDirections(isRtl);
    var ref = useMemo(function() {
        return buildStyle(theme, direction, {
            width: width,
            height: height,
            padding: padding,
            selectedIndicatorPlacement: selectedIndicatorPlacement,
            selectedIndicatorOffset: selectedIndicatorOffset
        });
    }, [
        width,
        height,
        padding,
        selectedIndicatorPlacement,
        selectedIndicatorOffset,
        theme,
        direction
    ]), container = ref.container, iconWrapper = ref.iconWrapper, content = ref.content, selectedIcon = ref.selectedIcon;
    return {
        container: _objectSpread({}, container.base, (clickable || selectable) && (!isDisabled || !hasError) && container.interactive, selected && container.selected, hasError && container.error, isDisabled && container.disabled),
        iconWrapper: iconWrapper,
        content: content,
        selectedIcon: selectedIcon
    };
};
